import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { DataService_NotifyReport } from "../notify-report-services/notifyreport.service";
import { StudentRegRequest } from "../notify-report-services/StudentRegRequest";

@Component({
	selector: "app-notify-student-reg",
	templateUrl: "./notify-student-reg.component.html",
	styleUrls: ["./notify-student-reg.component.css"],
})
export class NotifyStudentRegComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private notifyService: DataService_NotifyReport,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		GradeLevelID: 0,
		AcademyID: 0,
		HomeroomID: 0,
		GroupID: 0,
		AlreadySignedUpID: -1,
		SortBy: "FirstName",
		SortDirection: "ASC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	AlreadySignedUpList: any = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 0,
			Desc: "Not Signed Up",
		},
		{
			ID: 1,
			Desc: "Already Signed Up",
		},
	];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "StudentID",
			Desc: "Student ID",
		},
		{
			ID: "School",
			Desc: "School",
		},
		{
			ID: "ExpireDT",
			Desc: "Expire Date",
		},
		{
			ID: "ParentCount",
			Desc: "Number of Guardians Signed Up",
		},
	];
	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 454;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
		this.loadLogolist();
	}

	private loadGradeLevel() {
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length == 0) {
					this.GradeLevelList.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "Any",
					});
				}

				this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private loadAcademy() {
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length == 0) {
					this.AcademyList.unshift({
						AcademyID: -1,
						AcademyDesc: "Any",
					});
				}

				this.report.AcademyID = this.AcademyList[0].AcademyID;
			},
			(error) => {}
		);
	}

	private loadHomeroom() {
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length == 0) {
					this.HomeroomList.unshift({
						HomeroomID: -1,
						HomeroomDesc: "Any",
					});
				}

				this.report.HomeroomID = this.HomeroomList[0].HomeroomID;
			},
			(error) => {}
		);
	}

	private loadGroup() {
		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length == 0) {
					this.GroupList.unshift({
						GroupID: -1,
						GroupName: "Any",
					});
				}

				this.report.GroupID = this.GroupList[0].GroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		this.errorMessage = "";

		this.isProcessing = true;

		var parms: StudentRegRequest = {
			SchoolID: this.report.SchoolID,
			GradeLevelID: this.report.GradeLevelID,
			AcademyID: this.report.AcademyID,
			HomeroomID: this.report.HomeroomID,
			GroupID: this.report.GroupID,
			AlreadySignedUpID: this.report.AlreadySignedUpID,
			SortBy: this.report.SortBy,
			SortDirection: this.report.SortDirection,
			ImageLogo: this.report.ImageLogo,
			ReportOutputTypeID: this.OutputTypeID,
		};

		var result = this.notifyService.PrintStudentRegReport(parms);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.Success == undefined) {
					window.open(response);
				} else {
					this.errorMessage = response.Message;
				}
			},
			(error) => {
				this.isProcessing = false;
				this.errorMessage = error;
			}
		);
	}

	//
	// OLD Using Normal Report Service
	//
	// Print() {
	// 	var component = this;
	// 	this.errorMessage = "";

	// 	var strParam = this.GetStrParam();
	// 	this.isProcessing = true;

	// 	var reportID = 454;

	// 	var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

	// 	result.subscribe(
	// 		(response: any) => {
	// 			component.isProcessing = false;
	// 			window.open(response);
	// 		},
	// 		(error) => {
	// 			component.errorMessage = error;
	// 			component.isProcessing = false;
	// 		}
	// 	);
	// }

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 3: AcademyID
		strParam += "," + this.report.AcademyID + "|AcademyID";

		//Parameter 4: HomeRoomID
		strParam += "," + this.report.HomeroomID + "|HomeRoomID";

		//Parameter 5: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 6: AlreadySignedUp
		strParam += "," + this.report.AlreadySignedUpID + "|AlreadySignedUp";

		//Parameter 7: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 8: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 9: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 10: ImageLogo
		strParam += "," + this.report.ImageLogo + "|ImageLogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
